// Generated by CoffeeScript 1.9.3
var React;

React = require('react');

module.exports = function(options) {
  return React.createClass({
    displayName: "GoogleFont",
    render: function() {
      var fonts, fontsStr;
      fontsStr = "";
      fonts = options.googleFonts.map(function(font) {
        var str;
        str = "";
        str += font.name.split(' ').join('+');
        str += ":";
        str += font.styles.join(',');
        return str;
      });
      fontsStr = fonts.join('|');
      if (fontsStr) {
        return React.DOM.link({
          href: "//fonts.googleapis.com/css?family=" + fontsStr,
          rel: "stylesheet",
          type: "text/css"
        });
      } else {
        return null;
      }
    }
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/typography/dist/components/GoogleFont.js
 ** module id = 441
 ** module chunks = 0
 **/